import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";

const  initialState={
    kitchenBaseHandleData:[],
    kitchenBaseHandleLoader:true,
    kitchenBaseHandleError:"",
}

export const fetchKitchenBaseHandleList = createAsyncThunk('fetchkitchenBaseHandle',
async()=>{
    const projectList = await db
    .collectionGroup("base_cabinet_handle")
    // .where("status", "==", "Ongoing")
    // .where("ID", "==", auth.currentUser.uid)
    .get();
  const projectListArray = [];
  for (var snap of projectList.docs) {
    var data = snap.data();
    data.ID = snap.id;
    projectListArray.push({
      ...data,
    });
    if (projectListArray.length === projectList.docs.length) {
      return projectListArray
    }
  }
});

const kitchenBaseHandleReducer = createSlice({
    name:'kitchenBaseHandle',
    initialState,
    reducers:{},
    extraReducers:{
        [fetchKitchenBaseHandleList.fulfilled]:(state,action)=>{
            state.kitchenBaseHandleData = action.payload
            state.kitchenBaseHandleLoader = false
        },
        [fetchKitchenBaseHandleList.pending]:(state,action)=>{
            state.kitchenBaseHandleLoader = true
        },
        [fetchKitchenBaseHandleList.rejected]:(state,action)=>{
            state.kitchenBaseHandleError = "refresh the page"
        },
    }
});

export default kitchenBaseHandleReducer.reducer